import React from 'react';
import styles from './Header.module.scss';
import zadkineLogo from 'src/assets/images/zadkine-logo.png';
import { ReactComponent as FlatlandLogo } from 'src/assets/images/flatland-logo.svg';
import { Icon, IconName } from 'src/components/common/Icon/Icon';
import { Heading } from 'src/components/common/Heading/Heading';

export interface HeaderProps {
  actions?: Array<{
    label: string;
    icon?: IconName;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  }>;
}

export const Header: React.VFC<HeaderProps> = ({ actions }) => {

  const handleBackToHome = () => window.location.href = window.location.origin + window.location.pathname;

  return (
    <div className={styles['c-header']}>
      <button className={styles['c-header__logo']} onClick={handleBackToHome}>
        <img src={zadkineLogo} alt="Zadkine logo" className={styles['c-header__logo-img']} />
        <Heading className={styles['c-header__logo-tagline']} size="h1" as="h4">Collegeplan 2022-2026</Heading>
      </button>
      <div className={styles['c-header__nav']}>
        {actions?.map(({ label, icon, onClick }) => (
          <button type="button" onClick={onClick} key={label} className={styles['c-header__nav-item']}>
            {icon && <Icon name={icon} />}
            <span>{label}</span>
          </button>
        ))}
        <FlatlandLogo />
      </div>
    </div>
  );
};
